export default __webpack_public_path__ + "static/media/ground.e567f4fc.svg";